export default __webpack_public_path__ + "static/what-is-it-2-bb09030de966847801f6c136991a0b42.png";